import React, { useState, useEffect } from "react";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { CiSearch, CiCircleCheck } from "react-icons/ci";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import { BsCircle, BsCheckCircleFill, BsCopy } from "react-icons/bs";
import PageLoader from "../components/PageLoader";
import Header from "../components/Header";

const Promotions = () => {
  const { id } = useParams();
  const [isLoader, setIsLoader] = useState(false);
  const [promos, setPromos] = useState([]);
  

  useEffect(() => {
    window.scrollTo(0, 0);
    getPromotions();

  }, []);
  

  const getPromotions = async () => {
    try {
      setIsLoader(true);
    
      const response = await ApiService.request({
        method: "GET",
        url: "/getPromotions",
      });
      const data = response.data;

      console.log(data);
      if (data.status) {
        const item=data.data;
        setPromos(item.promos);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  
  return (
    <div>
      {isLoader ?(
          <PageLoader />
        ):(
      <div className="main-heading container loyality-points">
        
        <Header title={'Promotions'} />
        

        <div className="row mx-3">
          {promos && promos.map((promo) => (
            <div className="col-md-4 my-2">
                <Link to={'/promo/'+promo._id} className="card">
                  <img src={promo.image} alt="promo-img" className="promo-img" />
                  <div className="p-3">
                    <h5>{promo.title}</h5>
                    <p>{promo.description}</p>
                  </div>
                </Link>
            </div>
          ))}

        </div>

        
        
      </div>
      )};
    </div>
  );
}

export default Promotions;
